export const CentroUrlProd = 'https://admin.microsoft.com';

export const CentroUrlInt = 'https://admin-ignite.microsoft.com';

export const CentroFloodgateContainerId = 'obf-FloodgateDynamicUxContainer';

export const CentroFloodgateInitOptions = 'centro.hvc.floodgate.initOptions';

export const CentroThemeInitOptions = 'centro.hvc.floodgate.theme';

export const CentroCommonInitOptions = 'centro.hvc.feature';

export const CentroFloodgateFeatureName = 'floodgate';

export const CentroFloodgateHostName = 'host-floodgate-websdk';

export const CentroFloodgatePerfPrefix = 'FloodgateWebSDK';

export const CentroFloodgateLoggerFunc = 'floodgateCentroLogger';

export const CentroPreloadLoggingSamplingRate = 0.01; // sampling rate 1%

export const CentroPetrolUploadEndpoint = 'petrol';

export const FloodgateCentroVersion = 'v1';